import React from 'react';
import { Box, Button, Typography, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Lock } from '@material-ui/icons';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
  },
  separator: {
    position: 'absolute',
    top: '18px',
    left: 0,
    right: 0,
    height: 1,
    backgroundColor: theme.palette.grey[300],
    zIndex: 0,
  },
  buttonContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  unlockButton: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1, 2),
    color: theme.palette.text.primary,
    textTransform: 'none',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    minWidth: 140,
    position: 'relative',
    zIndex: 1,
    '&:hover': {
      backgroundColor: theme.palette.grey[50],
      borderColor: theme.palette.grey[400],
    },
  },
  buttonContent: {
    display: 'flex',
    alignItems: 'center',
    gap: `${theme.spacing(1) + 1}px`,
  },
  lockIcon: {
    fontSize: '1rem',
  },
}));

interface Props {
  stageName: string;
  onUnlock: () => void;
  disabled?: boolean;
  autoUnlockEnabled?: boolean;
}

const StageUnlockButton: React.FC<Props> = ({ stageName, onUnlock, disabled = false, autoUnlockEnabled = false }) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.separator} />
      <Box className={classes.buttonContainer}>
        <Button className={classes.unlockButton} onClick={onUnlock} disabled={disabled}>
          <Box className={classes.buttonContent}>
            <Lock className={classes.lockIcon} />
            <Typography variant='body2' style={{ fontWeight: 400, fontSize: '13px', color: '#666' }}>
              Unlock {stageName}?
            </Typography>
          </Box>
        </Button>
        {autoUnlockEnabled && (
          <Typography
            variant='caption'
            style={{ fontSize: '11px', color: '#888', textAlign: 'center', marginTop: '8px', display: 'block' }}
          >
            will unlock automatically
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export { StageUnlockButton };
